module.exports = __webpack_public_path__ + "media/svgs/tree-3669de33.svg";